<div id="popup">
  <div class="title-head index-head" fxLayout="row" fxLayoutAlign="space-between center">
    <span style="color: white;">
      Send Message
    </span>
    <button [attr.guide]="'send-sms-popup-btn-1' + '__' + sanitizedUrl" mat-icon-button>
      <mat-icon (click)="close()">
        close
      </mat-icon>
    </button>
  </div>
  <mat-dialog-content [ngStyle.lt-md]="'max-height: 100%'" style=" MARGIN: 0PX; padding: 0px;">
    <div class="padding-11">
      <div fxLayout="column" style="overflow: auto;" [formGroup]="firstFormGroup">

        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">

          <mat-form-field appearance="outline" floatLabel="always" fxFlex>
            <mat-label>Send To </mat-label>
            <input [attr.guide]="'send-sms-popup-inp-to' + '__' + sanitizedUrl" required matInput formControlName="to"
              trim="blur" />
            <mat-error *ngIf="firstFormGroup.controls.to.errors?.required">
              Please fill out this field.
            </mat-error>
          </mat-form-field>

        </div>

        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">

          <mat-form-field fxFlex appearance="outline">
            <mat-label>Send From</mat-label>
            <mat-select formControlName="From" [disableOptionCentering]="true" required #singleSelect>
              <mat-option>
                <ngx-mat-select-search name="Phone Search" ngDefaultControl [formControl]="phoneNoFilterControl"
                  placeholderLabel="Phone Search" [preventHomeEndKeyPropagation]="true"
                  noEntriesFoundLabel="No data found">
                </ngx-mat-select-search>
              </mat-option>
              <mat-option (onSelectionChange)="setPhoneNoSelection($event,item)"
                *ngFor="let item of filteredphoneNoTypeList; let i=index;" [value]="item.phoneNumber">
                {{item.phoneNumber}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="firstFormGroup.controls.From.errors?.required">
              Please fill out this field.

            </mat-error>
          </mat-form-field>

        </div>

        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">

          <mat-form-field appearance="outline" floatLabel="always" fxFlex>
            <mat-label>Text Message</mat-label>

            <textarea [attr.guide]="'send-sms-popup-sel-body' + '__' + sanitizedUrl" placeholder="Type Message.."
              trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5 matInput formControlName="body"
              matInput required>
            </textarea>
            <mat-error *ngIf="firstFormGroup.controls.body.errors?.required">
              Please fill out this field.
            </mat-error>
          </mat-form-field>

        </div>

        <div class="padding-top10" fxLayoutAlign="end center" fxLayoutGap="10px">

          <button [attr.guide]="'send-sms-popup-btn-2' + '__' + sanitizedUrl" type="button" mat-raised-button
            (click)="close()">Cancel
          </button>

          <button [attr.guide]="'send-sms-popup-btn-3' + '__' + sanitizedUrl" [disabled]="text !='Send'"
            (click)="sendSms()" mat-raised-button>
            {{text}}
            <mat-icon *ngIf="text !='Send' ">
              <mat-spinner color="primary" diameter="20">
              </mat-spinner>
            </mat-icon>
          </button>
        </div>

        <div>
          <br>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>